import React from 'react';
import { Link } from 'react-router-dom';
// Native MUI Components
import { Button, Box, Typography, Container } from '@mui/material';
import { useI18n } from '@/hooks/useI18n';

const UnauthorizedPage: React.FC = () => {
  const { t } = useI18n();
  
  return (
    <Container maxWidth="sm">
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '100vh', 
          textAlign: 'center',
          gap: 3 
        }}
      >
        <Typography variant="h3" component="h1" color="error" fontWeight="bold">
          {t('pages.unauthorized.title')}
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
          {t('pages.unauthorized.message')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button 
            variant="contained" 
            component={Link} 
            to="/login"
          >
            {t('auth.loginButton')}
          </Button>
          <Button 
            variant="outlined" 
            component={Link} 
            to="/"
          >
            {t('common.backToHome')}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default UnauthorizedPage;
